import { useState, useEffect, useCallback, createContext, useContext } from 'react'
import { useSelector } from 'react-redux'
import ApiService from 'services/ApiService'

const BadgeCountsContext = createContext({ counts: {}, refresh: () => {} })

const POLL_INTERVAL = 60000 // 60 seconds

export function BadgeCountsProvider({ children }) {
    const [counts, setCounts] = useState({})
    const token = useSelector((state) => state.auth?.session?.token)

    const refresh = useCallback(async () => {
        if (!token) return
        try {
            const resp = await ApiService.fetchData({
                url: '/admin/dashboard/badge-counts',
                method: 'get',
            })
            if (resp.data?.data) {
                setCounts(resp.data.data)
            }
        } catch (e) {
            // silent fail
        }
    }, [token])

    useEffect(() => {
        refresh()
        const interval = setInterval(refresh, POLL_INTERVAL)
        return () => clearInterval(interval)
    }, [refresh])

    return (
        <BadgeCountsContext.Provider value={{ counts, refresh }}>
            {children}
        </BadgeCountsContext.Provider>
    )
}

export function useBadgeCounts() {
    return useContext(BadgeCountsContext)
}

// Map nav keys to badge count keys
export function getBadgeForNavKey(navKey, counts) {
    const map = {
        'appsSales.orderList': counts.orders,
        'appsSales.offers': counts.offers,
        'appsSales.disputes': counts.disputes,
        'appsSales.personalShopping': counts.personalShopping,
        'appsProducts.pendingReview': counts.pendingReview,
        'appsSales.reservations': counts.preOrders,
    }
    return map[navKey] || 0
}
